import { useTranslation } from "react-i18next";
import { useUID } from "../../../context/UIDContext";
import { useAmplitude } from "../../../context/AmplitudeContext";
import "./ProductCards.scss";
import { useTracker } from "../../../context/TrackerContext";

export const ProductCards = ({ products, onShowMoreClick }) => {
  const { t } = useTranslation("productModule");
  const { uid } = useUID();
  const trackEvent = useAmplitude();
  const { itrack } = useTracker();

  // track product click event
  const trackProductClick = (productTitle, productUrl) => {
    itrack({
      eventName: "clicked_product",
      trackerId: uid,
      properties: { product_name: productTitle ? productTitle : "" },
    });
    trackEvent(
      "webapp_user_clicked_product",
      uid,
      "",
      "",
      productTitle,
      productUrl,
    );
  };

  return (
    <div className="product-cards">
      {products.map((product, index) => (
        <div
          key={index}
          className="product-card"
          onClick={() => {
            trackProductClick(product.name, product.url);
            if (product.score !== undefined) {
              onShowMoreClick(product);
            }
          }}
        >
          <div className="product-img-container">
            <img
              src={
                product.imageUrl
                  ? `${product.imageUrl}`
                  : product.image
                    ? `data:image/png;base64, ${product.image}`
                    : "placeholder.png"
              }
              alt={product.name}
              className={
                !product.imageUrl && !product.image
                  ? "placeholder"
                  : "product-img"
              }
            />
          </div>
          <h4 className="product-brand">
            {product.brand === "" ? "\u00A0" : product.brand}
          </h4>
          {product.name && <h4 className="product-title">{product.name}</h4>}

          {product.price && (
            <div className="product-price-wrapper">
              <h4 className="current-product-price">
                {product.discountPrice !== undefined
                  ? product.discountPrice
                  : product.price}
              </h4>
              {product.discountPrice && (
                <div className="original-product-price">
                  {product.price}
                  <div className="strike-through-line" />
                </div>
              )}
            </div>
          )}

          {product.url && (
            <h4
              className="product-to-link-button"
              onClick={(e) => {
                e.stopPropagation();
                if (product.url) {
                  const newWindow = window.open(
                    product.url,
                    "_blank",
                    "noopener,noreferrer",
                  );
                  if (newWindow) newWindow.opener = null;
                }
              }}
            >
              {t("product-details")}
            </h4>
          )}
          {product.score !== undefined && (
            <div
              className={`score-badge ${product.score >= 0.75 ? "best_green" : product.score >= 0.5 ? "very_good_green" : "good_green"}`}
            >
              {product.score >= 0.75 ? (
                <p>{t("best-fit-tag")}</p>
              ) : product.score >= 0.5 ? (
                <p>{t("very-good-tag")}</p>
              ) : (
                <p>{t("good-tag")}</p>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
